import styles from './style/TPAModal.scss'
import React, { ComponentType, createRef, useEffect } from 'react'

export type ModalFeatureProps = {
	isMobileView: boolean
	isPreviewMode: boolean
	title?: string
	theme?: string
}

export type TPAModalProps = ModalFeatureProps & {
	id: string
	src: string
	width: number
	height: number
	closeModal: () => void
	styleOverrides?: { width?: number; height?: number }
}

const TPAModal: ComponentType<TPAModalProps> = (props) => {
	const IFRAME_CROSS_DOMAIN_PERMISSIONS = ['autoplay', 'camera', 'microphone', 'geolocation', 'vr'].join(';')

	const { id, src, width, height, closeModal, isMobileView, isPreviewMode, title, theme, styleOverrides } = props
	const dialog = createRef<HTMLDivElement>()

	useEffect(() => {
		if (typeof window !== 'undefined' && src && !isPreviewMode && dialog.current) {
			const node = dialog.current
			if (!node.contains(window.document.activeElement)) {
				node.focus()
			}
		}
	}, [dialog, isPreviewMode, src])

	const isBareModal = () => theme === 'BARE' || theme === 'LIGHT_BOX'

	const useWidth = styleOverrides?.width ?? width
	const useHeight = styleOverrides?.height ?? height

	const dialogStyle = isMobileView
		? {}
		: {
				width: useWidth,
				height: useHeight,
				marginTop: -useHeight / 2,
				marginLeft: -useWidth / 2,
		  }

	return (
		<div id={id} className={[styles.root, isBareModal() ? styles.bare : ''].join(' ')}>
			<div className={styles.blockingLayer} onClick={() => closeModal()} />
			<div
				className={styles.dialog}
				role="dialog"
				style={dialogStyle}
				aria-label={title || 'Modal Dialog'}
				ref={dialog}
			>
				<div className={styles.frameWrap}>
					<iframe
						name={id}
						className={styles.iframe}
						allowFullScreen={true}
						// @ts-ignore
						allowtransparency="true"
						frameBorder="0"
						src={src}
						title={title || 'Modal Dialog'}
						aria-label={title || 'Modal Dialog'}
						allow={IFRAME_CROSS_DOMAIN_PERMISSIONS}
					/>
					<button className={styles.xButton} aria-label="Close modal" onClick={() => closeModal()}>
						×
					</button>
				</div>
			</div>
		</div>
	)
}

export default TPAModal
